module.exports = __webpack_public_path__ + "img/1.b37bda6c.jpg";